const TEMPLATE = `
<section class="certificates-list-section fade-up">
    <div class="container-fluid">
        <!-- Контейнер для динамічного завантаження сертифікатів -->
        <div data-section="certificates-section" id="certificates-section">
            <!-- Сюди завантажуватимуться блоки сертифікатів -->
        </div>

        <div class="load-more-" data-animate-child data-delay="800">
            <button class="load-more-certificates">Завантажити більше</button>
        </div>

    </div>
</section>
`;

class BmlCertificatesList extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-certificates-list', BmlCertificatesList);
